import React, { type FC, useState } from 'react';

import { ButtonIconAction } from 'components/button/ButtonIconAction';
import { TagComponent } from 'components/tag/TagComponent';
import { Checkbox } from 'enable-ui';

import {
  CardName,
  CardType,
  CustomCheckbox,
  TagComponentStyle,
  TagContainer,
  ThumbnailContainer,
} from 'modules/dashboard/styles/card-item';

import { Card } from '../styles/dashboard';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const CardItem: FC<{
  selected: boolean;
  onChange: (id: string) => void;
  goToDetailPage: (id: string) => void;
  handleEdit: (id: string) => () => void;
  handleDelete: (id: string) => () => void;
  handleDuplicate: (id: string) => () => void;
  hideAction: boolean;
  name: string;
  type?: string;
  id: string;
  thumbnail: string;
  subTitle?: React.ReactNode;
  showCheckbox?: boolean;
  level?: number;
  isDefaultBFT?: boolean;
  tag?: React.ReactNode;
}> = ({
  selected,
  onChange,
  name,
  type,
  id,
  thumbnail,
  goToDetailPage,
  handleEdit,
  handleDelete,
  handleDuplicate,
  hideAction,
  subTitle,
  showCheckbox,
  isDefaultBFT,
  tag,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <ThumbnailContainer
        $bgImg={thumbnail}
        $bgColor={`${thumbnail ? '' : COLOR_CONFIG['crystal-cut']}`}
        onClick={() => goToDetailPage(id)}
      >
        {(showCheckbox || isHovered) && (
          <CustomCheckbox>
            <Checkbox
              checked={selected}
              onClick={(e) => {
                e.stopPropagation();
                onChange(id);
              }}
              style={{ position: 'absolute', padding: '10px 0px 0px 10px' }}
              className={selected ? 'active' : ''}
            />
          </CustomCheckbox>
        )}
        {isDefaultBFT && (
          <TagComponent
            text="Default baseline fitness test"
            customStyle={TagComponentStyle}
            color={COLOR.primary['primary-6']}
            isDot={false}
          />
        )}

        <TagContainer>{tag}</TagContainer>
      </ThumbnailContainer>
      <div
        className="full-width"
        style={{
          display: 'flex',
          maxHeight: 52,
          marginBottom: 2,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <CardName
          className="active-title"
          onClick={(e) => {
            e.stopPropagation();
            goToDetailPage(id);
          }}
        >
          {name}
        </CardName>
        {!hideAction && (
          <ButtonIconAction
            actions={[
              {
                label: 'Edit',
                onClick: handleEdit(id),
              },
              {
                label: 'Delete',
                onClick: handleDelete(id),
              },
              {
                label: 'Duplicate',
                onClick: handleDuplicate(id),
              },
            ]}
          />
        )}
      </div>

      {type && <CardType>{type}</CardType>}
      {subTitle}
    </Card>
  );
};
